import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'do0045',
    ecrans: ['00-2']
});
